import {
  FETCH_SHIPMENTS_DATA_REQUEST,
  FETCH_SHIPMENTS_DATA_SUCCESS,
  FILTER_SHIPMENTS_TYPE
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  page: 1,
  shipments: [],
  shipmentsCount: 0,
  status: "",
  isFetching: false,
  type: "buyer",
  isAllChecked: false
};

export const shipmentsReducer = createReducer(initialState, {
  [FETCH_SHIPMENTS_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false,
      isAllChecked: false
    };
  },
  [FETCH_SHIPMENTS_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  },
  [FILTER_SHIPMENTS_TYPE]: (state, payload) => {
    return {
      ...state,
      ...payload
    };
  }
});

export default shipmentsReducer;
